import type { RouteObject } from 'react-router-dom'

import Email from '@app/pages/onboarding/email'
import Organization from '@app/pages/onboarding/organization'
import User from '@app/pages/onboarding/user'
import Welcome from '@app/pages/onboarding/welcome'
import SessionShell from '@app/shared/layout/shells/sessionShell'
import { requiresUserConfig } from '@app/utils/auth'
import { loaderQuery } from '@graphql/client'
import { Playbooks } from '@graphql/documents/playbook.graphql'

const routes: RouteObject = {
  path: 'onboarding',
  element: <SessionShell />,
  children: [
    {
      path: 'user',
      loader: () => requiresUserConfig((user, identityId) => !!identityId),
      element: <User />
    },
    {
      path: 'organization',
      element: <Organization />
    },
    {
      path: 'verify_email',
      loader: () => requiresUserConfig((user) => !user?.confirmedAt),
      element: <Email />
    }
  ]
}

const loggedInRoutes: RouteObject = {
  loader: async () => {
    const response = await loaderQuery(Playbooks, { aiOnly: true })

    const playbooks = response?.data?.playbooks

    return { playbooks: playbooks }
  },
  path: '/welcome',
  element: <Welcome />
}

export default routes

export { loggedInRoutes }
